/// <reference path="../../types.d.ts"" />

import { Card } from '@codametrix/ui-components';
import classnames, { Argument } from 'classnames';
import React, { useState, useEffect } from 'react';
import './dashboard.scss';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tableau-viz': {
        id: string;
        src: string;
        token: string | undefined;
        toolbar: string;
        children: any;
      };

      'viz-filter': {
        field: string;
        value: string;
      };
    }
  }
}

const listeners = [
  'firstinteractive',
  'filterchanged',
  'parameterchanged',
  'markselectionchanged'
];

const TableauDashboard = (props: AppProps.DashboardView) => {
  const {
    tableauInfo,
    instantiateDashboard,
    serviceLine,
    tableauToken,
    activeHealthSystemCode,
    activeDashboardResource,
    registerActivity,
    dashboardPaths
  } = props;

  const [instantiated, setInstantiated] = useState<boolean>(false);

  useEffect(() => {
    if (tableauInfo?.enabled) {
      if (!instantiated) {
        setInstantiated(true);
        instantiateDashboard(serviceLine);
      }

      // Get the viz object from the HTML web component
      const viz = document.querySelector('tableau-viz');

      listeners.forEach(listener => {
        viz?.addEventListener(listener, registerActivity);
      });
    }
  }, [
    instantiated,
    instantiateDashboard,
    registerActivity,
    tableauInfo?.enabled,
    serviceLine,
    tableauToken
  ]);

  useEffect(() => {
    return () => {
      setInstantiated(false);

      const viz = document.querySelector('tableau-viz');
      listeners.forEach(listener => {
        viz?.removeEventListener(listener, registerActivity);
      });
    };
  }, [registerActivity]);

  const { loadState } = props;
  const styleClasses: Argument = ['dashboard-view'];
  const showCard = loadState.error || tableauInfo?.enabled === false;
  let message;
  if (showCard) {
    message = loadState.error
      ? `An error has occurred loading the dashboard.`
      : `Analytics is not enabled.  Please contact someone from CodaMetrix for more information.`;
  }

  const serviceLineFilter = serviceLine?.name?.length
    ? `${serviceLine?.name?.replace(/ /g, '')}`
    : '';
  // Temporary hardcoding, our dashboards do not support AMCHS org code at this time
  const healthSystemCodeFilter =
    activeHealthSystemCode !== 'AMCHS' ? activeHealthSystemCode : '';

  const filters =
    serviceLine && serviceLine?.name?.length > 0 ? (
      <>
        <viz-filter field="Service Line" value={serviceLineFilter}></viz-filter>
        <viz-filter
          field="Health System Code"
          value={healthSystemCodeFilter}></viz-filter>
      </>
    ) : (
      <viz-filter
        field="Health System Code"
        value={healthSystemCodeFilter}></viz-filter>
    );

  const link = activeDashboardResource
    ? `${tableauInfo?.siteUrl}${dashboardPaths[activeDashboardResource]}`
    : '';

  return (
    <div className={classnames(styleClasses)}>
      {tableauInfo?.enabled && instantiated ? (
        <tableau-viz
          id="tableauViz"
          src={link}
          token={tableauToken}
          toolbar="hidden">
          {filters}
        </tableau-viz>
      ) : (
        <Card className="content-vacant">
          {' '}
          <h2>{message}</h2>
        </Card>
      )}
    </div>
  );
};

export default TableauDashboard;
